import React from 'react';
import throttle from 'lodash/throttle';

const useClientWidth = () => {
  const isClient = typeof window === 'object';

  const [clientWidth, setclientWidth] = React.useState(0);

  React.useEffect(() => {
    if (!isClient) {
      return;
    }

    const handleResize = throttle(() =>
      setclientWidth(document.body.clientWidth)
    );

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [isClient]);

  return clientWidth;
};

export default useClientWidth;
